{
  "chart": {
    "how-to-measure": "Zo meet je op",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "Selecteer je maat, we laten je weten wanneer deze weer op voorraad is"
  },
  "page": {
    "plans": {
      "try-now": "Nu proberen",
      "what-included": "Wat is inbegrepen?",
      "popular-plan": "Populair"
    },
    "about-us": {
      "title": "Over ons",
      "intro": "Goodchart is in 2023 opgericht met de missie om jouw kledingervaring te transformeren. Ons team van modeliefhebbers, ontwerpers en technologie-experts staat klaar om je te helpen kleding te vinden die echt bij je lichaam past. Met onze gebruiksvriendelijke interface en geavanceerde algoritmen bieden we gepersonaliseerde aanbevelingen op basis van je maten, stijl en levensstijl.",
      "community": "Zeg vaarwel tegen compromissen en welkom tegen vertrouwen en comfort. Sluit je aan bij onze inclusieve community van tevreden klanten en ga op een vreugdevolle winkelreis met Goodchart.",
      "tagline": "Laat je stijl los. Ervaar pure mode-euforie.",
      "founders": "Oprichters",
      "cedric-photo-alt": "Cedric, medeoprichter en Head of Product bij Goodchart",
      "nick-photo-alt": "Nick, medeoprichter en Operation Director bij Goodchart",
      "quentin-photo-alt": "Quentin, Head of Information Technology bij Goodchart",
      "cedric": "Cedric",
      "cedric-role": "Medeoprichter en Head of Product bij Goodchart",
      "nick": "Nick",
      "nick-role": "Medeoprichter en Operation Director bij Goodchart",
      "quentin": "Quentin",
      "quentin-role": "Head of Information Technology bij Goodchart"
    },
    "contact": {
      "title": "Neem contact met ons op",
      "lets-talk": "Laten we praten",
      "subtitle": "Vul het formulier in en ons team neemt per e-mail contact met je op.",
      "first-name": "Voornaam",
      "first-name-required": "Voornaam is verplicht",
      "last-name": "Achternaam",
      "last-name-required": "Achternaam is verplicht",
      "email": "E-mail",
      "email-required": "E-mail is verplicht",
      "email-invalid": "Voer een geldig e-mailadres in",
      "message": "Bericht",
      "message-required": "Bericht is verplicht",
      "sending": "Bezig met verzenden...",
      "send": "Verzenden",
      "success": "Je formulier is naar ons team verzonden!"
    },
    "email-unsubscribe": {
      "title": "E-mailaanmelding",
      "unsubscribe-confirm": "Weet je zeker dat je je wilt afmelden voor onze mailinglijst?",
      "unsubscribe-info": "Als je je afmeldt, ontvang je geen updates, nieuwsbrieven en speciale aanbiedingen meer van ons.",
      "cancel": "Annuleren",
      "confirm-unsubscription": "Afmelding bevestigen",
      "resubscribe-confirm": "Wil je je opnieuw aanmelden voor onze mailinglijst?",
      "resubscribe-info": "Blijf op de hoogte van ons laatste nieuws, exclusieve aanbiedingen en interessante updates.",
      "resubscribe": "Opnieuw aanmelden",
      "unsubscribe-success": "Afmelding van je e-mail is gelukt",
      "unsubscribe-error": "Er is een probleem opgetreden bij het afmelden van je e-mail",
      "resubscribe-success": "Heraanmelding van je e-mail is gelukt",
      "resubscribe-error": "Er is een probleem opgetreden bij het opnieuw aanmelden van je e-mail"
    },
    "back-to-stock": {
      "notify-me-product": "Informeer mij voor het product {{title}} - {{variant}}"
    },
    "help": {
      "title": "Helpcentrum",
      "description": "Handleidingen voor het instellen en gebruiken van Goodchart in je Shopify-winkel.",
      "search": "Zoek in helpartikelen",
      "loading": "Laden…",
      "load-failed": "Het helpcentrum kon niet worden geladen. Probeer het zo opnieuw.",
      "no-results": "Geen artikelen gevonden voor je zoekopdracht.",
      "no-articles": "Er zijn nog geen helpartikelen.",
      "topics": {
        "getting-started": "Aan de slag",
        "size-charts": "Maattabellen",
        "table-charts": "Tabellen",
        "assigning-products": "Producten toewijzen",
        "storefront-display": "Weergave in de winkel",
        "chart-import": "Tabellen importeren",
        "size-recommendations": "Maatadvies",
        "plans-billing": "Abonnementen en facturering",
        "troubleshooting": "Problemen oplossen"
      },
      "back": "Terug naar het helpcentrum",
      "browse": "Naar het helpcentrum",
      "not-found": {
        "title": "Artikel niet gevonden",
        "description": "Dit artikel bestaat niet of is niet meer beschikbaar."
      },
      "updated": "Laatst bijgewerkt op {{date}}",
      "related": "Meer over {{topic}}",
      "contact": {
        "title": "Nog steeds hulp nodig?",
        "description": "Stuur ons een bericht en ons team neemt per e-mail contact met je op. Heb je de Goodchart-app geïnstalleerd, dan kun je ook vragen stellen in de supportchat van de app.",
        "link": "Neem contact met ons op"
      },
      "article-load-failed": "Dit artikel kon niet worden geladen. Probeer het zo opnieuw."
    }
  },
  "error": {
    "error-occurred": "Er is een fout opgetreden!",
    "failed-to-subscribe-to-this-product": "Aanmelden voor dit product is mislukt!",
    "failed-to-get-your-size-recommendation-please-try-again-later": "Je maataanbeveling kon niet worden opgehaald. Probeer het later opnieuw."
  },
  "common": {
    "close": "Sluiten"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "Vind je beste maat",
        "subtitle": "Enkele snelle details voor een betere pasvorm",
        "shopping-for": "SHOPPEN VOOR",
        "gender-women": "Dames",
        "gender-men": "Heren",
        "gender-other": "Anders",
        "measurements": "METINGEN",
        "height": "Lengte",
        "height-required": "Lengte is verplicht",
        "height-min": "Minimale lengte is 1",
        "weight": "Gewicht",
        "weight-required": "Gewicht is verplicht",
        "weight-min": "Minimaal gewicht is 1",
        "preferred-fit": "Voorkeurspasvorm",
        "continue": "Doorgaan"
      },
      "result": {
        "suggested-size": "Voorgestelde maat:",
        "no-fit": "Helaas lijkt het erop dat we op dit moment geen ideale maat hebben. We raden aan later terug te komen voor meer opties.",
        "verdict": "Oordeel:",
        "similar-variants": "Vergelijkbare varianten:",
        "proceed": "Doorgaan met deze variant",
        "estimate-disclaimer": "(Schatting gebaseerd op merk en gebruikersinformatie, resultaten kunnen variëren.)",
        "back": "Terug"
      }
    },
    "footer": {
      "terms": "Voorwaarden",
      "privacy": "Privacy",
      "help-center": "Helpcentrum",
      "blog": "Blog",
      "about": "Over ons",
      "contact-us": "Neem contact met ons op"
    },
    "conversion-table": {
      "description": "Afhankelijk van de pasvorm kunnen er lichte verschillen in de metingen voorkomen. Zoek je juiste maat in de onderstaande tabel.",
      "size": "Maat"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "Informeer mij wanneer beschikbaar",
      "notify-me": "Informeer mij",
      "out-of-stock": "Niet op voorraad"
    },
    "restock-form": {
      "your-name": "Je naam",
      "your-email": "Je e-mailadres",
      "email-required": "E-mail is verplicht",
      "subscribing": "Bezig met aanmelden...",
      "notify-me": "INFORMEER MIJ",
      "agree-terms": "Door verder te gaan, ga je akkoord met onze",
      "terms-privacy": "Voorwaarden en privacybeleid",
      "news-opt-in": "Ik wil graag updates ontvangen over nieuwe introducties en andere inspirerende content (optioneel)"
    },
    "back-to-stock-result": {
      "new-subscription": "Bedankt, we sturen je een e-mail zodra maat <span class=\"font-bold\">{{name}}</span> beschikbaar is.",
      "existing-subscription": "We hebben je e-mailadres! We laten je weten zodra maat <span class=\"font-bold\">{{name}}</span> weer op voorraad is.",
      "back-to-collection": "Terug naar de collectie"
    },
    "chart": {
      "find-your-size": "Vind je maat",
      "size-guide": "Maattabel",
      "recommendation": "Aanbeveling",
      "body-measurements": "LICHAAMSMATEN",
      "model-measurements": "MODELMATEN",
      "model-description": "Model {{name}} is {{height}}cm en draagt maat {{variant}}.",
      "size-conversion": "MAATOMREKENING"
    },
    "landing": {
      "learn": "Leren",
      "learn-more": "Meer informatie",
      "blog": "Blog",
      "blog-description": "Ontdek de laatste aankondigingen, productupdates en meer",
      "help-center": "Helpcentrum",
      "help-center-description": "Aan de slag, how-to-artikelen en stapsgewijze instructies",
      "demo": "Demo",
      "demo-description": "Bekijk Goodsize-widgets in actie in onze voorbeeldwinkel",
      "services": "DIENSTEN",
      "contact": "Contact",
      "privacy": "Privacy",
      "goodsize": "Goodsize",
      "goodsize-description": "Ontdek onze pasvormoplossing voor jouw bedrijf",
      "goodchart": "Goodchart",
      "goodchart-description": "Visuele maattabel om de conversie te verhogen"
    },
    "product-variant-completer": {
      "title": "Kies je opties",
      "body": "Selecteer je {{option}} om door te gaan.",
      "body-multiple": "Selecteer de resterende opties om door te gaan.",
      "body-notify": "Welke {{option}} moeten we voor je in de gaten houden?",
      "confirm": "Doorgaan",
      "cancel": "Annuleren",
      "empty": "Deze combinatie is niet beschikbaar."
    },
    "checkout-variant": {
      "label": "Je koopt {{variant}}",
      "aria-label": "Wijzig de variant die je koopt",
      "sold-out": "uitverkocht"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday"
    }
  }
}
